import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useToast } from '@/view/components/ui/use-toast'
import { transactionsService } from '../services/transactionService'
import { GetCommissionParams } from '../services/transactionService/getCommission'

export const useGetTransactionCommission = (params: GetCommissionParams) => {
  const { toast } = useToast()

  const { data, isLoading, isFetching, isError } = useQuery({
    queryKey: ['commission', params],
    queryFn: () => transactionsService.getCommission(params),
    enabled: !!params?.type,
  })

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregar a comissão, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    data,
    isLoading,
    isFetching,
  }
}
